// extracted by mini-css-extract-plugin
module.exports = {"imageGroup":"SectionImage_imageGroup__YsUnQ","additionalText":"SectionImage_additionalText__jQzEa"};